import * as React from 'react';
import debounce from 'lodash.debounce';
import { fuzzyFilter } from '../utils';
/**
 * `useFilterList()` provides state and update methods to manage the result of
 * filtering a list of objects by a given key
 *
 * @param items An array of objects to filter
 * @param filterBy The key used to filter the items by
 * @param [string] initialSearch
 */
export function useFilterList(
/* eslint-disable-next-line */
items, filterBy, initialSearch, delay) {
    if (items === void 0) { items = []; }
    if (initialSearch === void 0) { initialSearch = ''; }
    if (delay === void 0) { delay = 300; }
    var _a = React.useState(initialSearch), searchString = _a[0], setSearchString = _a[1];
    var _b = React.useState(items), filteredItems = _b[0], setFilteredItems = _b[1];
    var data = React.useMemo(function () { return items; }, [items]);
    // Cache callbacks to avoid fresh function references
    var resetFilter = React.useCallback(function () {
        if (searchString !== '') {
            setSearchString('');
            applyFilter('');
        }
    }, []);
    var applyFilter = React.useCallback(function (search) {
        var filtered = fuzzyFilter(search, filterBy, data);
        setFilteredItems(filtered);
    }, [data]);
    // apply the initial search string and filter if it exists
    React.useEffect(function () {
        applyFilter(initialSearch);
    }, [data]);
    // when the search string updates, apply the debounced filter, cleaning up the
    // debounce when it's done
    React.useEffect(function () {
        var applyFilterDebounced = debounce(applyFilter, delay);
        applyFilterDebounced(searchString);
        return function () {
            applyFilterDebounced.cancel();
        };
    }, [searchString]);
    return {
        rawData: data,
        applyFilter: setSearchString,
        resetFilter: resetFilter,
        searchString: searchString,
        filteredItems: filteredItems
    };
}
//# sourceMappingURL=useFilterList.js.map